export default "__VITE_ASSET__CbNdBoz9__"